module.exports = __webpack_public_path__ + "static/media/git.d19bbdb4.png";